import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialNotificationState, INotification } from "./notification.types";
import {
  fetchNotifications,
  fetchNotificationsRules,
} from "./notificationThunk";
import { LoadState } from "../../constants/enums";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: initialNotificationState,
  reducers: {
    addNotification: (state, action: PayloadAction<INotification>) => {
      state.list.unshift(action.payload);
      state.unreadCount += 1;
    },

    setNotifications: (state, action: PayloadAction<INotification[]>) => {
      state.list = action.payload;
      state.unreadCount = action.payload.filter((n) => n.read_status !== "READ").length;
    },

    markRead: (state, action: PayloadAction<string>) => {
      const index = state.list.findIndex((n) => n.notification_code === action.payload);
      if (index === -1 || state.list[index].read_status === "READ") return;
      state.list[index] = { ...state.list[index], read_status: "READ" };
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },

    markAllRead: (state) => {
      state.unreadCount = 0;
      state.list = state.list.map((n) => ({
        ...n,
        isRead: true,
      }));
    },
    clearNotificationsRules: (state) => {
      state.notificationRule.list = [];
      state.notificationRule.loading = LoadState.NotLoaded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.pending, (state) => {
      state.loading = LoadState.InProgress;
    });
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.loading = LoadState.Loaded;

      state.list = [...state.list, ...action.payload.notifications];
      state.unreadCount = state.list.filter((n) => n.read_status !== "READ").length;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchNotifications.rejected, (state) => {
      state.loading = LoadState.Failed;
    });
    builder.addCase(fetchNotificationsRules.pending, (state) => {
      state.notificationRule.loading = LoadState.InProgress;
      state.notificationRule.list = [];
    });
    builder.addCase(fetchNotificationsRules.fulfilled, (state, action) => {
      state.notificationRule.loading = LoadState.Loaded;
      state.notificationRule.list = action.payload.notificationsRules;
    });
    builder.addCase(fetchNotificationsRules.rejected, (state) => {
      state.notificationRule.loading = LoadState.Failed;
      state.notificationRule.list = [];
    });
  },
});

export const { addNotification, setNotifications, markRead, markAllRead,clearNotificationsRules } =
  notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;
